var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscussions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18C1.8 18 0 16.2 0 14V4C0 1.8 1.8 0 4 0H20C22.2 0 24 1.8 24 4V14C24 16.2 22.2 18 20 18H16V24L10 18H4ZM40 30C42.2 30 44 28.2 44 26V16C44 13.8 42.2 12 40 12H28V14C28 18.4 24.4 22 20 22V26C20 28.2 21.8 30 24 30H28V36L34 30H40Z",
    fill: "#322C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussions);
export default __webpack_public_path__ + "static/media/discussions.db896f0669062574153070e4a901ecd5.svg";
export { ForwardRef as ReactComponent };